/* eslint-disable import-x/no-default-export */
import { MockList } from '@graphql-tools/mock';
import Chance from 'chance';

const chance = new Chance();

const organisations = [
  'Catho',
  'Certsy',
  'Coursera',
  'Jobstreet.com',
  'JobsDB.com',
  'Jora',
  'OES',
  'OCC',
  'Seek',
  'Seek Learning',
  'Sidekicker',
  'Zhaopin',
];

export default () => {
  const organisation = chance.pickone(organisations);

  return {
    id: `http://graph.seek.com/organisation/${chance.integer({
      min: 0,
      max: 9999,
    })}`,
    matchedVariant: organisation,
    normalisedText: organisation,
    highlights: () => new MockList([0, 1]),
  };
};
